import React from "react";
import { ReactComponent as FacebookIcon } from "../../assets/images/facebook.svg";
import { ReactComponent as InstagramIcon } from "../../assets/images/instagram.svg";
import { ReactComponent as LinkedinIcon } from "../../assets/images/linkedin.svg";
import { ReactComponent as TwitterIcon } from "../../assets/images/twitter.svg";
import PropTypes from "prop-types";
import "./SocialMediaLink.scss";

export default function SocialMediaLink({ platform, urls, classes = [""], text = null }) {
  let url = urls[platform];
  if (!url) return null;
  if (!url.includes("http://") && !url.includes("https://")) {
    url = "https://" + url;
  }
  let Icon;
  let label;
  switch (platform) {
    case "FACEBOOK":
      Icon = FacebookIcon;
      label = "Facebook";
      break;
    case "INSTAGRAM":
      Icon = InstagramIcon;
      label = "Instagram";
      break;
    case "LINKED_IN":
      Icon = LinkedinIcon;
      label = "LinkedIn";
      break;
    case "TWITTER":
      Icon = TwitterIcon;
      label = "Twitter";
      break;
    default:
      Icon = null;
  }
  if (!Icon) return null;
  return (
    <a className={classes.join(" ")} href={url} target="_blank" rel="noopener noreferrer">
      {!text ? (
        <>
          <Icon />
          <span>{label}</span>
        </>
      ) : (
        text
      )}
    </a>
  );
}

SocialMediaLink.propTypes = {
  classes: PropTypes.array,
};
